module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content front in-page"
  }, [_c('Breadcrumb', {
    attrs: {
      "lstBreadcrumb": _vm.lstBreadcrumb
    }
  }), _c('div', {
    staticClass: "box-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 box-content"
  }, [_vm._v(_vm._s(_vm.$t("home.comming_soon")))])]), _c('div', {
    staticClass: "clearfix"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6998184e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/Page/policy.vue
// module id = 1594
// module chunks = 0